//C:\Users\PC1\mi-imprenta\mi-app\frontend\src\main.jsx
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.jsx";
import "./index.css";
import { installTenantRequestContext } from "./lib/tenant.js";
import { AuthProvider } from "./auth/AuthContext.jsx";
import { isMarketingHostname } from "./lib/host.js";
import { installNumericInputUx } from "./lib/numericInputUx.js";

installTenantRequestContext();
installNumericInputUx();

const application = (
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    {isMarketingHostname() ? application : <AuthProvider>{application}</AuthProvider>}
  </React.StrictMode>
);
